module.exports = __webpack_public_path__ + "media/images/Logo hortense-Noir-4dcf6537abd1158a792a11e92df546c8.svg";